<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import simplebar from "simplebar-vue";
import Stat from "@/components/widgets/stat";
import axios from "axios";
import Drawer from "vue-simple-drawer";
import { activityChart, mostUsedAppChart } from "./data-activity";

export default {
  page: {
    title: "User Activity",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Drawer,
    simplebar,
    Layout,
    PageHeader,
    Stat,
    DatePicker,
  },
  data() {
    return {
      loginData: {},
      lang: 'es',
      curr: {
        empId: null,
        name: "N.A",
        email: "N.A",
        designation: "N.A",
        teamName: "N,A",
      },
      employees: [],
      workingTabsMetaData: {
        date: "",
        time: "",
        activeMins: "",
      },
      liveActivityData: [
        /*{
          startHour: 10,
          activeMins: 35,
          appUsage: 'Chrome, Phtoshop',
        },
         {
          startHour: 11,
          activeMins: 45,
          appUsage: 'Netbeans, MobaExterm',
        },
         {
          startHour: 12,
          activeMins: 40,
          appUsage: 'Iterm, Chrome',
        },
         {
          startHour: 1,
          activeMins: 30,
          appUsage: 'Terminus, Filezilla',
        },
         {
          startHour: 2,
          activeMins: 20,
          appUsage: 'Chrome, Visual Studio',
        },
         {
          startHour: 3,
          activeMins: 10,
          appUsage: 'Filezilla, Iterm',
        },*/
      ],
      tableActivityData: [],
      activityChart: activityChart,
      mostUsedAppChart: mostUsedAppChart,
      detailedActivityData: [
      ],
      title: "User Activity",
      actDate: "",
      selectedDate: "",
      empLoader: false,
      hideActivityDashboardData: false,
      hideActivityGraphData: false,
      hideLiveActivityData: false,
      hideActivityTableData: false,
      hideAppUsageData: false,
      hideDetailedActivityData: false,
      openLeftDrawer: false,
      filterValue: "",
      statData: [
        {
          icon: "bx bx-time",
          title: 'menuitems.reports.thisYear',
          value: "0 hrs",
        },
        {
          icon: "bx bx-hourglass",
          title: 'menuitems.reports.thisMonth',
          value: "0 hrs",
        },
        {
          icon: "bx bx-analyse",
          title: 'menuitems.reports.today',
          value: "0 hrs",
        },
      ],
    };
  },
  methods: {
    onEmployeeChange(data) {
      this.curr = data;
      this.actDate = new Date();
      this.selectedDate = this.actDate.toISOString().slice(0,10);
      this.getApiData();
      setTimeout(() => {
        this.openLeftDrawer = false;
      }, 300);
    },
    onDateChange() {
      if(this.actDate == null) {
        this.selectedDate = "";
        return;
      }
      var date = new Date(this.actDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.getActivityData();
    },
    leftDrawer() {
      this.openLeftDrawer = !this.openLeftDrawer;
    },
    openModal() {
      document.body.classList.add("modal-open");
    },
    closeModal() {
      document.body.classList.remove("modal-open");
    },
    changeWorkingTabData(startHour, activeMinutes, isLive) {
      var fullDate = new Date(),
        mnth = ("0" + (fullDate.getMonth() + 1)).slice(-2),
        day = ("0" + fullDate.getDate()).slice(-2);
      let date = [fullDate.getFullYear(), mnth, day].join("-");
      if(isLive == false) {
        date = this.selectedDate;
      }
      let endHour = parseInt(startHour) + 1;
      this.workingTabsMetaData.date = date;
      this.workingTabsMetaData.time = startHour + ":00:00" + " - " + endHour + ":00:00";
      this.workingTabsMetaData.activeMins = activeMinutes;
      this.getDetailedActivityData(date, startHour, endHour);
    },
    getApiData() {
      this.getLiveActivityData();
      this.getActivityData();
      this.getActivityGraphData();
      this.getActivityDashboardData();
      this.getMostAppUsageData();
    },
    async getAllEmployees(empRouteData) {
      this.empLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.employees = response.data.data;
            if(empRouteData) {
              for(var i = 0;i < this.employees.length;i++) {
                if(this.employees[i].empId == empRouteData.empId) {
                  this.curr = this.employees[i];
                }
              }
            } else {
              this.curr = this.employees[0];
            }
            this.getApiData();
            this.empLoader = false;
          }
        }
      } catch (error) {
        this.empLoader = false;
      }
      this.empLoader = false;
    },
    async getLiveActivityData() {
      this.hideLiveActivityData = true;
      this.liveActivityData = [];
      var fullDate = new Date(),
        mnth = ("0" + (fullDate.getMonth() + 1)).slice(-2),
        day = ("0" + fullDate.getDate()).slice(-2);
      let date = [fullDate.getFullYear(), mnth, day].join("-");
      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/logs",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
              date: date,
              timezone: this.curr.timezone,
            },
          }
        );
        //console.log(response.data);
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.liveActivityData = response.data.data;
          }
        }
      } catch (error) {
       // console.log(error);
      }
      this.hideLiveActivityData = false;
    },
    async getActivityData() {
      this.hideActivityTableData = true;
      this.tableActivityData = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/logs",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
              date: this.selectedDate,
              timezone: this.curr.timezone,
            },
          }
        );
        
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.tableActivityData = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.hideActivityTableData = false;
    },
    async getActivityDashboardData() {
      this.hideActivityDashboardData = true;
      this.statData[0].value = "0 hrs";
      this.statData[1].value = "0 hrs";
      this.statData[2].value = "0 hrs";
      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/activity_dashboard",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
              timezone: this.curr.timezone,
            },
          }
        );
        if(response.data.success == "true") {
          this.statData[0].value = response.data.data.thisYearCount.toString();
          this.statData[1].value = response.data.data.thisMonthCount.toString();
          this.statData[2].value = response.data.data.todayCount.toString();
        }
      } catch (error) {
        //console.log(false);
      }
      this.hideActivityDashboardData = false;
    },
    async getDetailedActivityData(date, startHour, endHour) {
      this.hideDetailedActivityData = true;
      this.detailedActivityData = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/working_tabs",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
              date: date,
              startHour: startHour,
              endHour: endHour,
              timezone: this.curr.timezone,
            },
          }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.detailedActivityData = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.hideDetailedActivityData = false;
    },
    async getMostAppUsageData() {
      this.hideAppUsageData = true;
      for (var i = 0; i < 5; i++) {
        this.mostUsedAppChart.series[i] = 0;
        this.mostUsedAppChart.chartOptions.labels[i] = "N.A";
      }

      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/most_app_usage_employee",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
            },
          }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for (i = 0; i < response.data.data.length; i++) {
              var appName = response.data.data[i].appName;
              var appCount = response.data.data[i].appCount;

              if (isNaN(appCount)) {
                this.mostUsedAppChart.series[i] = 0;
              } else {
                this.mostUsedAppChart.series[i] = appCount;
              }
              this.mostUsedAppChart.chartOptions.labels[i] = appName;
              
            }
            window.dispatchEvent(new Event('resize'));
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.hideAppUsageData = false;
    },
    async getActivityGraphData() {
      this.hideActivityGraphData = true;
      for (var i = 0; i < 12; i++) {
        this.activityChart.series[0].data[i] = 0;
      }
      try {
        const response = await axios.get(
          process.env.VUE_APP_ACTIVITY_URL + "/activity_report/active_hours_graph",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
              year: 0,
              timezone: this.curr.timezone,
            },
          }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for (i = 0; i < response.data.data.length; i++) {
              var count = response.data.data[i].avgActiveHours;
              if (isNaN(count)) {
                this.activityChart.series[0].data[i] = 0;
              } else {
                this.activityChart.series[0].data[i] = count;
              }
            }
             window.dispatchEvent(new Event("resize"));
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.hideActivityGraphData = false;
    },
  },
  
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.actDate = new Date();
    if(this.$route.params.date) {
      let splits = this.$route.params.date.split(' ');
      let month = 1;
      switch(splits[1]) {
        case 'Jan' :
          month = 1;
          break;
        case 'Feb' :
          month = 2;
          break;
        case 'Mar' :
          month = 3;
          break;
        case 'Apr' :
          month = 4;
          break;
        case 'May' :
          month = 5;
          break;
        case 'Jun' :
          month = 6;
          break;
        case 'Jul' :
          month = 7;
          break;
        case 'Aug' :
          month = 8;
          break;
        case 'Sep' :
          month = 9;
          break;
        case 'Oct' :
          month = 10;
          break;
        case 'Nov' :
          month = 11;
          break;
        case 'Dec' :
          month = 12;
          break;
      }
      let dateStr = splits[2] + '-' + month + '-' + splits[0];
      this.actDate = new Date(dateStr);
      let date = new Date(dateStr),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      console.log(this.selectedDate);
    } else {
      let date = new Date(),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
    }
    this.getAllEmployees(this.$route.params.data);
  },
  computed: {
    searchevents: function () {
      var result = this.employees;
      if (!this.filterValue) return result;

      const filterValue = this.filterValue.toLowerCase();

      const filter = (event) =>
        event.name.toLowerCase().includes(filterValue) ||
        event.email.toLowerCase().includes(filterValue);

      return result.filter(filter);
    },
  },
  watch: {
  '$i18n.locale': function(newVal) {
    this.lang = newVal;
  }
}
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.reports.list.activity')" />
    <div class="row">
      <div class="col-xl-4">
        <div class="is-loading">
          <div class="preloader-component" v-show="empLoader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card overflow-hidden">
            <div class="bg-soft bg-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-3">
                    <h5 class="text-primary">{{ $t('menuitems.reports.activityReports') }}</h5>
                    <p>{{ $t('menuitems.reports.seeDetailedActivityOfUser') }}</p>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img
                    src="@/assets/images/profile-img.png"
                    alt
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-sm-4">
                  <div class="avatar-md profile-user-wid mb-4">
                    <span
                      class="
                        avatar-title
                        rounded-circle
                        bg-soft bg-info
                        text-primary
                        fs-1
                      "
                      v-if="curr.name != null"
                      >{{ curr.name.charAt(0) }}</span
                    >
                  </div>
                  <h5 class="font-size-15 text-truncate">{{curr.name}}</h5>
                  <p class="text-muted mb-0 text-truncate">{{curr.designation}}</p>
                </div>

                <div class="col-sm-8">
                  <div class="pt-4">
                    <div class="row">
                      <div class="col-12">
                        <p class="text-muted mb-0 text-truncate">
                          {{ $t('menuitems.teams.team') }} : <span class="text-dark">{{curr.teamName}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="text-muted mb-0 text-truncate">
                          {{ $t('menuitems.reports.email') }}  :
                          <span class="text-dark">{{curr.email}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="mt-4">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="leftDrawer"
                      >
                        {{ $t('menuitems.reports.changeEmployee') }}
                        <i class="mdi mdi-arrow-right ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="is-loading">
          <div class="preloader-component" v-show="hideLiveActivityData">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body" style="height: calc(100vh - 351px);">
              <h4 class="card-title mb-4">{{ $t('menuitems.reports.liveActivity') }}</h4>
              <div v-if="liveActivityData.length > 0" class>
                <ul class="verti-timeline list-unstyled">
                  <simplebar
                    style="max-height: calc(100vh - 451px); padding-left: 15px"
                    ref="current"
                    id="containerElement"
                  >
                   <li class="event-list active" v-if="
                                    liveActivityData.length > 0
                                  ">
                      <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                      </div>
                      <div class="d-flex">
                        <div class="me-3">
                          <i class="bx bx-time h4 text-primary"></i>
                        </div>
                        <div class="flex-grow-1">
                          <div>
                            <h5 class="font-size-15">
                              <a href="javascript: void(0);" class="text-dark"
                                ><span
                                  v-if="
                                    liveActivityData.length > 0 &&
                                    liveActivityData[
                                      liveActivityData.length - 1
                                    ].startHour < 10
                                  "
                                  >0</span
                                >{{
                                  liveActivityData[liveActivityData.length - 1]
                                    .startHour
                                }}:00 -
                                <span
                                  v-if="
                                    liveActivityData.length > 0 &&
                                    liveActivityData[0].startHour < 10
                                  "
                                  >0</span
                                >{{
                                  liveActivityData[liveActivityData.length - 1]
                                    .startHour + 1
                                }}:00</a
                              >
                            </h5>
                            <span class="text-secodary"
                              >{{ $t('menuitems.reports.activeFor') }}
                              {{
                                liveActivityData[liveActivityData.length - 1]
                                  .activeMins
                              }}
                              Mins
                              <span
                                v-if="
                                  liveActivityData[liveActivityData.length - 1]
                                    .appUsage != ''
                                "
                                >{{ $t('menuitems.reports.andCaptured') }}
                                {{
                                  liveActivityData[liveActivityData.length - 1]
                                    .appUsage
                                }}
                                etc.</span
                              >
                              <b-button
                                v-b-modal.workingTabsModal
                                pill
                                variant="outline-primary"
                                size="sm"
                                @click="
                                  changeWorkingTabData(
                                    liveActivityData[
                                      liveActivityData.length - 1
                                    ].startHour, liveActivityData[
                                      liveActivityData.length - 1
                                    ].activeMins, true
                                  )
                                "
                                >{{ $t('menuitems.reports.view') }} <i class="bx bx-right-arrow-alt"></i
                              ></b-button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      v-for="(activityData, index) in liveActivityData.slice(0,liveActivityData.length - 1).reverse()"
                      :key="index"
                      class="event-list"
                    >
                      <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle"></i>
                      </div>
                      <div class="d-flex">
                        <div class="me-3">
                          <i class="bx bx-time h4 text-primary"></i>
                        </div>
                        <div class="flex-grow-1">
                          <div>
                            <h5 class="font-size-15">
                              <a href="javascript: void(0);" class="text-dark"
                                ><span v-if="activityData.startHour < '10'"
                                  >0</span
                                >{{ activityData.startHour }}:00 -
                                <span v-if="activityData.startHour < '10'"
                                  >0</span
                                >{{ activityData.startHour + 1 }}:00</a
                              >
                            </h5>
                            <span class="text-secodary"
                              >{{ $t('menuitems.reports.activeFor') }} {{ activityData.activeMins }} Mins
                              <span
                                v-if="
                                  activityData.appUsage != ''
                                "
                                >{{ $t('menuitems.reports.andCaptured') }} {{ activityData.appUsage }} etc.</span
                              >
                              <b-button
                                v-b-modal.workingTabsModal
                                pill
                                variant="outline-primary"
                                size="sm"
                                @click="
                                  changeWorkingTabData(activityData.startHour, activityData.activeMins, true)
                                "
                                >{{ $t('menuitems.reports.view') }} <i class="bx bx-right-arrow-alt"></i
                              ></b-button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>

                    <!--<li class="event-list">
                      <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle"></i>
                      </div>
                      <div class="d-flex">
                        <div class="me-3">
                          <i class="bx bx-time h4 text-primary"></i>
                        </div>
                        <div class="flex-grow-1">
                          <div>
                            <h5 class="font-size-15">
                              <a href="javascript: void(0);" class="text-dark"
                                >UI /UX Designer</a
                              >
                            </h5>
                            <span class="text-secodary"
                              >Active for 45 Mins and used Chrome, Notepad etc.
                              <a href="#">View</a>
                            </span>
                          </div>
                        </div>
                      </div>-->
                  </simplebar>
                </ul>
              </div>
              <div v-if="liveActivityData.length <= 0">
              <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 10%;margin-left: 22%;" height="180" width="180"><br />
              <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
            </div>
            </div>
          </div>
        </div>
        <!-- end card -->
        <div class="is-loading">
          <div class="preloader-component" v-show="hideAppUsageData">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body" style="height : 365px">
              <h4 class="card-title mb-3">{{ $t('menuitems.reports.mostUsedApps') }}</h4>

              <div class="col-lg-12" >
                <apexchart
                  v-if="mostUsedAppChart.series[0] > 0 && mostUsedAppChart.series[1] > 0 && mostUsedAppChart.series[2] > 0 && mostUsedAppChart.series[3] > 0 && mostUsedAppChart.series[4] > 0"
                  class="apex-charts"
                  height="320"
                  type="donut"
                  dir="ltr"
                  :series="mostUsedAppChart.series"
                  :options="mostUsedAppChart.chartOptions"
                ></apexchart>
                <div v-else>
                  <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 9%;margin-left: 22%;" height="180" width="180"><br />
                  <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
              </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
            <div class="is-loading">
              <div class="preloader-component" v-show="hideActivityDashboardData">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <Stat :icon="stat.icon" :title="$t(stat.title)" :value="stat.value" />
            </div>
          </div>
        </div>
        <div class="is-loading">
          <div class="preloader-component" v-show="hideActivityGraphData">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-5">{{ $t('menuitems.reports.activityOverview') }}</h4>
              <div id="revenue-chart" class="apex-charts"></div>
              <apexchart
                class="apex-charts"
                type="bar"
                height="320"
                :series="activityChart.series"
                :options="activityChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body" style="height: calc(100vh - 265px);">
            <div class="row mb-2">
              <div class="col-md-3">
                <h4 class="card-title mb-4">{{ $t('menuitems.reports.activityLogs') }}</h4>
              </div>
              <div class="col-md-6 text-end">
                <!--<span class="link-primary font-size-17 text-decoration-underline">Export</span>-->
              </div>
              <div class="col-md-3">
                <date-picker
                  v-model="actDate"
                  :first-day-of-week="1"
                  lang="en"
                  @change="onDateChange"
                ></date-picker>
              </div>
            </div>
            <simplebar
              style="height: calc(100vh - 385px);"
              ref="current"
              id="containerElement1"
            >
              <div class="is-loading">
                <div class="preloader-component" v-show="hideActivityTableData">
                  <div class="status">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>

                <div v-if="tableActivityData.length > 0" class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                      <tr>
                        <th scope="col">{{ $t('menuitems.reports.startTime') }}</th>
                        <th scope="col">{{ $t('menuitems.reports.activeMinutes') }}</th>
                        <th scope="col">{{ $t('menuitems.reports.idleMinutes') }}</th>
                        <th scope="col">{{ $t('menuitems.reports.appUsage') }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(activityData, index) in tableActivityData"
                        :key="index"
                      >
                        <th scope="row">
                          <span v-if="activityData.startHour < '10'">0</span
                          >{{ activityData.startHour }} : 00
                        </th>
                        <td>{{ activityData.activeMins }} Mins</td>
                        <td>{{ activityData.idleMins }} Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            ><span v-if="activityData.appUsage == ''">....</span
                            >{{ activityData.appUsage }}</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="
                              changeWorkingTabData(activityData.startHour, activityData.activeMins, false)
                            "
                            >{{ $t('menuitems.reports.view') }} <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <!-- <tr>
                        <th scope="row">10:00 AM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                       <tr>
                        <th scope="row">11:00 AM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                       <tr>
                        <th scope="row">12:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">01:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">02:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">03:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">04:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">05:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">06:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">07:00 PM</th>
                        <td>45 Mins</td>
                        <td>15 Mins</td>
                        <td>
                          <span
                            class="d-inline-block text-truncate pe-2"
                            style="max-width: 250px"
                            >Chrome, Notepad, MobaExterm, WordPad, Skype</span
                          >
                          <b-button
                            v-b-modal.workingTabsModal
                            pill
                            variant="info"
                            size="sm"
                            @click="changeWorkingTabData('11:00:00')"
                            >View <i class="bx bx-right-arrow-alt"></i
                          ></b-button>
                        </td>
                      </tr>-->
                      <b-modal
                        @show="openModal"
                        @hidden="closeModal"
                        id="workingTabsModal"
                        centered
                        scrollable
                        :title="$t('menuitems.reports.detailedActivity')"
                        title-class="font-18"
                        size="lg"
                        hide-footer
                      >
                        <div class="is-loading">
                          <div class="preloader-component" v-show="hideDetailedActivityData">
                            <div class="status">
                              <div class="spinner-chase">
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <span class="me-5 fw-bolder"
                              >{{ $t('menuitems.reports.date') }}: {{workingTabsMetaData.date}}</span
                            >
                            <span class="ms-5 fw-bolder"
                              >{{ $t('menuitems.reports.time') }}: {{workingTabsMetaData.time}}</span
                            >
                            <span class="ms-5 fw-bolder">{{ $t('menuitems.reports.active') }}: {{workingTabsMetaData.activeMins}} Mins</span>
                          </div>
                          <div class="table-responsive">
                            <table class="table table-nowrap table-hover mb-0">
                              <thead>
                                <tr>
                                  <th scope="col">{{ $t('menuitems.reports.time') }}</th>
                                  <th scope="col">{{ $t('menuitems.reports.capturedApplicationWindow') }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(detailedActData, index) in detailedActivityData"
                                  :key="index"
                                >
                                  <th scope="row">
                                    {{ detailedActData.time }}
                                  </th>
                                  <td>
                                    <span
                                      class="d-inline-block text-truncate pe-2"
                                      style="max-width: 5000px"
                                      >{{ detailedActData.openTab }}</span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </b-modal>
                    </tbody>
                  </table>
                </div>
                <div v-else style="margin-top: 20%;margin-left: 30%;" >
                  <img src="@/assets/images/no-data.png" alt="No Data" height="180" width="180"><br />
                  <span class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
              </div>
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <Drawer
      @close="leftDrawer"
      :align="'left'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openLeftDrawer">
        <div class="offcanvas-header">
          <h4
            class="offcanvas-title text-truncate"
            id="offcanvasExampleLabel"
            style="width: 320px"
          >
            {{ $t('menuitems.reports.selectEmployee') }}
          </h4>
        </div>

        <div class="offcanvas-body mt-0">
          <div class="search-box py-2">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('menuitems.reports.search')"
                v-model="filterValue"
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
          <div>
            <simplebar style="max-height: calc(100vh - 230px)">
              <ul class="list-unstyled chat-list">
                <li
                  class
                  v-for="data of searchevents"
                  :key="data.empId"
                  @click="onEmployeeChange(data)"
                  :class="{ active: curr.empId == data.empId }"
                >
                  <a href="javascript: void(0);">
                    <div class="row">
                      <div class="col-md-1">
                        <i
                          :class="`mdi mdi-circle text-${data.color} font-size-10`"
                        ></i>
                      </div>
                      <div class="avatar-xs col-md-3" style="width: 55px">
                        <span
                          class="
                            avatar-title
                            rounded-circle
                            bg-soft bg-primary
                            text-primary
                          "
                          >{{ data.name.charAt(0) }}</span
                        >
                      </div>
                      <div class="col-md-8">
                        <span class="text-truncate font-size-14 mb-1">{{
                          data.name
                        }}</span>
                        <p class="text-truncate mb-0">{{ data.email }}</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </simplebar>
          </div>
        </div>
      </div>
    </Drawer>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>